import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const languages = [
    { code: 'es', label: 'Español', flag: '🇪🇸' },
    { code: 'en', label: 'English', flag: '🇺🇸' },
  ];

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-white/80 hover:text-white text-sm font-medium cursor-pointer whitespace-nowrap transition-colors px-2 py-1 rounded-lg hover:bg-white/10"
      >
        <span>{current.flag}</span>
        <span className="hidden sm:inline">{current.label}</span>
        <i className={`ri-arrow-down-s-line text-sm transition-transform ${open ? 'rotate-180' : ''}`}></i>
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)}></div>
          <div className="absolute right-0 top-full mt-2 bg-white rounded-xl overflow-hidden z-50 min-w-[140px] border border-[#E5E5E5]">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleChange(lang.code)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm cursor-pointer transition-colors whitespace-nowrap ${
                  current.code === lang.code
                    ? 'bg-[#FF6B35]/10 text-[#FF6B35] font-semibold'
                    : 'text-[#0A1628] hover:bg-[#F8F9FA]'
                }`}
              >
                <span>{lang.flag}</span>
                <span>{lang.label}</span>
                {current.code === lang.code && (
                  <i className="ri-check-line ml-auto text-[#FF6B35]"></i>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
